const orderTypeCodes = {
  Z001: 'FUTURES ORDER',
  Z002: 'FUTURES CONTRACT',
  Z003: 'AT-ONCE ORDER',
  Z004: 'FUTURES CALL-OFF',
  Z005: 'AT-ONCE CALL-OFF',
  Z006: 'AT-ONCE CONTRACT',
  Z007: 'AT-ONCE PRODUCT COMP',
  Z008: 'MKTG FUTURES',
  Z009: 'MKTG EVENTS AT-ONCE COMP',
  Z010: 'MARKETING CONTRACT',
  Z011: 'MARKETING CALL-OFF',
  Z012: 'SALESMAN SAMPLES',
  Z013: 'INTERNAL CONTRACT',
  Z014: 'CUST AT-ONCE CALL-O',
  Z015: 'VISUAL MERCH',
  Z016: 'CHARITABLE COMP',
  Z017: 'REPLEN CONTRACT',
  Z018: 'REPLEN CALL-OFF',
  Z019: 'REPLEN FUTURE-CONTRACT',
  Z020: 'CUST FUTURES CALL-O',
  Z021: 'SAMPLES TEMPLATE',
  Z022: 'SHARED CONTRACT FUTURE',
  Z023: 'SHARED CONTRACT AT-ONCE',
  Z024: 'Z024',
  Z025: 'Z025',
  Z033: 'DIGITAL SALES ORDER',
  Z100: 'RETURN',
  Z101: 'CREDIT MEMO REQUEST',
  Z102: 'DEBIT MEMO REQUEST',
  Z103: 'EVENTS/COMP RETURN',
  ZP04: 'SO TYPE FOR STOCKTRANSFER',
  ECS: 'ELITE ORDERS',
  ZSTA: 'Standard Order',
  ZCON: 'Standard Contract',
  ZDIG: 'Digital Rush Order',
  ZFRE: 'Free of Charge Order',
  ZRST: 'Standard Returns',
  ZRSS: 'Standard Rtrn SubRSO',
  ZRFR: 'Free Returns',
  ZRFS: 'Free Returns Sub RSO',
  ZS01: 'DC to DC',
  ZS02: 'DC to DC',
  ZS05: 'DC Store Intra STO',
  ZS06: 'DC Store Inter STO',
  ZS07: 'Store store Intra STO',
  ZS11: 'Store Returns - Intra Company STO',
  ZS12: 'Returns Inter STO / Store Returns Cross Company STO',
  // converse
  EC: 'Converse: Electronic Commerce',
  RA: 'Converse: Retail Apparel',
  RF: 'Converse: Retail Footwear',
  SA: 'Converse: Samples Apparel',
  SF: 'Converse: Samples Footwear',
  WA: 'Converse: Wholesale Apparel',
  WF: 'Converse: Wholesale footwear',
}

const orderTypeCodesArray = [
  { value: 'Z001', label: 'Z001: FUTURES ORDER' },
  { value: 'Z002', label: 'Z002: FUTURES CONTRACT' },
  { value: 'Z003', label: 'Z003: AT-ONCE ORDER' },
  { value: 'Z004', label: 'Z004: FUTURES CALL-OFF' },
  { value: 'Z005', label: 'Z005: AT-ONCE CALL-OFF' },
  { value: 'Z006', label: 'Z006: AT-ONCE CONTRACT' },
  { value: 'Z007', label: 'Z007: AT-ONCE PRODUCT COMP' },
  { value: 'Z008', label: 'Z008: MKTG FUTURES' },
  { value: 'Z009', label: 'Z009: MKTG EVENTS AT-ONCE COMP' },
  { value: 'Z010', label: 'Z010: MARKETING CONTRACT' },
  { value: 'Z011', label: 'Z011: MARKETING CALL-OFF' },
  { value: 'Z012', label: 'Z012: SALESMAN SAMPLES' },
  { value: 'Z013', label: 'Z013: INTERNAL CONTRACT' },
  { value: 'Z014', label: 'Z014: CUST AT-ONCE CALL-O' },
  { value: 'Z015', label: 'Z015: VISUAL MERCH' },
  { value: 'Z016', label: 'Z016: CHARITABLE COMP' },
  { value: 'Z017', label: 'Z017: REPLEN CONTRACT' },
  { value: 'Z018', label: 'Z018: REPLEN CALL-OFF' },
  { value: 'Z019', label: 'Z019: REPLEN FUTURE-CONTRACT' },
  { value: 'Z020', label: 'Z020: CUST FUTURES CALL-O' },
  { value: 'Z021', label: 'Z021: SAMPLES TEMPLATE' },
  { value: 'Z022', label: 'Z022: SHARED CONTRACT FUTURE' },
  { value: 'Z023', label: 'Z023: SHARED CONTRACT AT-ONCE' },
  { value: 'Z024', label: 'Z024: Z024' },
  { value: 'Z025', label: 'Z025: Z025' },
  { value: 'Z033', label: 'Z033: DIGITAL SALES ORDER' },
  { value: 'Z100', label: 'Z100: RETURN' },
  { value: 'Z101', label: 'Z101: CREDIT MEMO REQUEST' },
  { value: 'Z102', label: 'Z102: DEBIT MEMO REQUEST' },
  { value: 'Z103', label: 'Z103: EVENTS/COMP RETURN' },
  { value: 'ZP04', label: 'ZP04: SO TYPE FOR STOCKTRANSFER' },
  { value: 'ECS', label: 'ECS: ELITE ORDERS' },
  { value: 'ZSTA', label: 'ZSTA: Standard Order' },
  { value: 'ZCON', label: 'ZCON: Standard Contract' },
  { value: 'ZDIG', label: 'ZDIG: Digital Rush Order' },
  { value: 'ZFRE', label: 'ZFRE: Free of Charge Order' },
  { value: 'ZRST', label: 'ZRST: Standard Returns' },
  { value: 'ZRSS', label: 'ZRSS: Standard Rtrn SubRSO' },
  { value: 'ZRFR', label: 'ZRFR: Free Returns' },
  { value: 'ZRFS', label: 'ZRFS: Free Returns Sub RSO' },
  { value: 'ZS01', label: 'ZS01: DC to DC' },
  { value: 'ZS02', label: 'ZS02: DC to DC' },
  { value: 'ZS05', label: 'ZS05: DC Store Intra STO' },
  { value: 'ZS06', label: 'ZS06: DC Store Inter STO' },
  { value: 'ZS07', label: 'ZS07: Store store Intra STO' },
  { value: 'ZS11', label: 'ZS11: Store Returns - Intra Company STO' },
  { value: 'ZS12', label: 'ZS12: Returns Inter STO / Store Returns Cross Company STO' },
  { value: 'EC', label: 'EC (Converse): Electronic Commerce' },
  { value: 'RA', label: 'RA (Converse): Retail Apparel' },
  { value: 'RF', label: 'RF (Converse): Retail Footwear' },
  { value: 'SA', label: 'SA (Converse): Samples Apparel' },
  { value: 'SF', label: 'SF (Converse): Samples Footwear' },
  { value: 'WA', label: 'WA (Converse): Wholesale Apparel' },
  { value: 'WF', label: 'WF (Converse): Wholesale footwear' },
]

export function getOrderTypeCode(orderTypeCode: number) {
  return orderTypeCodes[orderTypeCode] || '?'
}

export function getOrderTypeCodes() {
  return orderTypeCodesArray
}

export function getSelectedOrderTypeCodes(orderTypeCodes: string[]) {
  return orderTypeCodes
    ? orderTypeCodesArray.filter((orderTypeCodeOption) =>
        orderTypeCodes.includes(orderTypeCodeOption.value)
      )
    : []
}
